// @noflow
import { connect } from 'react-redux';
import { getConfig } from '~/core/state/config/selectors';
import NewWebsiteAlert from './component';
import { setAppSettings } from '~/core/state/app-settings/actions';
import { THANK_YOU_ACCEPTED } from '~/core/constants/app-settings';

const mapStateToProps = state => ({
    faqLink: getConfig(state, 'help:faqLink')
});

const mapDispatchToProps = dispatch => ({
    dismissPopup: () => {
        dispatch(setAppSettings({ [THANK_YOU_ACCEPTED]: true }));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(NewWebsiteAlert);



// WEBPACK FOOTER //
// ./src/components/widgets/new-website-popup/index.js